module.exports = __webpack_public_path__ + "img/18.56e7aeef.png";